import { writable } from 'svelte/store'
import { onRoute } from '~/utils/router'
import { removeBy } from '~/helpers/array'

let newDialogIds = 0

export interface Dialog {
  id?: string
  component: any
  attrs: Record<string, any>
}

// Dialogs that are currently being displayed.
export const dialogs = writable<Dialog[]>([])

// Adds a dialog to the current window.
//
// NOTE: It's not possible to open several dialogs with the same id.
// An unique id is auto-generated unless one is provided.
export function addDialog ({ component, attrs, id = `dialog-${newDialogIds++}` }: Dialog) {
  dialogs.update((dialogs) => {
    if (!dialogs.some(dialog => dialog.id === id))
      dialogs.push({ component, attrs, id })
    return dialogs
  })
  return id
}

// Removes a dialog from the current window.
export function removeDialog ({ id }: Dialog) {
  dialogs.update((dialogs) => {
    removeBy(dialogs, dialog => dialog.id === id)
    return dialogs
  })
}

// Closes all dialogs.
export function closeAllDialogs () {
  dialogs.update(() => [])
}

onRoute(closeAllDialogs)
